import Pricing2 from './Pricing2'
export default Pricing2
